var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blender-statistic-chart main-block"},[_c('div',{staticClass:"blender-statistic-chart-controls"},_vm._l((_vm.chartItems),function(item){return _c('div',{key:item.name,class:[
        'blender-statistic-chart-controls__item',
         {'blender-statistic-chart-controls__item--current': item.name === _vm.currentChart.name}
      ],on:{"click":function($event){_vm.currentChart = item}}},[_vm._v(_vm._s(item.name))])}),0),(_vm.chartData && _vm.chartData.length)?_c('MyChart',{attrs:{"chartData":_vm.chartData,"stroke":'#a0a5d5'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }